import React, { useRef, useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedBlob from "../core/cropImage";
import Modal from "./Modal";

/** انتخاب تصویر با برش (crop). onPick(blob) */
export default function ImageField({ label, preview, aspect = 1, outW = 400, outH = 400, onPick, onRemove, onError, busy, round, hint }) {
  const ref = useRef(null);
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);

  const pick = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!/^image\/(png|jpe?g|webp)$/.test(file.type)) return onError?.("فقط تصویر PNG، JPG یا WEBP مجاز است");
    if (file.size > 8 * 1024 * 1024) return onError?.("حجم تصویر بیش از ۸ مگابایت است");
    const r = new FileReader();
    r.onload = () => { setCrop({ x: 0, y: 0 }); setZoom(1); setSrc(r.result); };
    r.readAsDataURL(file);
  };

  const confirm = async () => {
    if (!area) return;
    const blob = await getCroppedBlob(src, area, outW, outH);
    setSrc(null);
    onPick(blob);
  };

  return (
    <div className="field">
      <label>{label}</label>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{
          width: 86, height: 86 / aspect, minHeight: 50, border: "1.5px dashed var(--border)", borderRadius: round ? "50%" : 12, overflow: "hidden",
          display: "grid", placeItems: "center", background: "var(--card-2)", color: "var(--muted)", flex: "none",
        }}>
          {preview ? <img src={preview} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} /> : <i className="fa-regular fa-image" />}
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={() => ref.current.click()}>
            {busy ? "در حال ارسال..." : preview ? "تغییر تصویر" : "انتخاب تصویر"}
          </button>
          {preview && onRemove && <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={onRemove}>حذف</button>}
        </div>
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={pick} />
      </div>
      {hint && <div className="hint">{hint}</div>}

      {src && (
        <Modal title="برش تصویر" onClose={() => setSrc(null)}
          footer={<><button className="btn" onClick={confirm}>تأیید</button><button className="btn btn-ghost" onClick={() => setSrc(null)}>انصراف</button></>}>
          <div className="hint" style={{ marginBottom: 8 }}>برای دیدن کل تصویر (کوچک‌کردن)، نوار زوم را به چپ ببرید؛ فضای خالی شفاف می‌ماند.</div>
          <div style={{ position: "relative", height: 320, background: "#111", borderRadius: 12, overflow: "hidden", direction: "ltr" }}>
            <Cropper image={src} crop={crop} zoom={zoom} aspect={aspect} onCropChange={setCrop} onZoomChange={setZoom} minZoom={0.3} maxZoom={3} restrictPosition={false}
              onCropComplete={(_, px) => setArea(px)} cropShape={round ? "round" : "rect"} showGrid={false} />
          </div>
          <input type="range" min="0.3" max="3" step="0.05" value={zoom} onChange={(e) => setZoom(Number(e.target.value))} style={{ margin: "14px 0 8px", padding: 0, border: "none" }} />
        </Modal>
      )}
    </div>
  );
}
